import React, { FC, ReactElement } from 'react';
import { Box, Button, Paragraph, Text } from 'grommet';
import { Subheading } from '@/components/Subheading';
import { ThemeModeImage } from '@/components/ThemeModeImage';
import styled, { css } from 'styled-components';
import { normalizeColor } from 'grommet/utils';

const LeftCircle = styled.div`
  ${({ theme }) => css`
    position: fixed;
    background-color: ${normalizeColor(`status-critical`, theme)};
    left: -50px;
    bottom: 0;
    opacity: 0.15;
    border-radius: 100%;
    height: 5vw;
    width: 5vw;
    z-index: 0;
    max-height: 70px;
    max-width: 70px;
    box-shadow: 0 0 70px 70px ${normalizeColor(`status-critical`, theme)};
  `}
`;

export const About: FC = (): ReactElement => (
  <Box direction="row-responsive" pad="medium">
    <Box animation="slideRight">
      <LeftCircle />
      <ThemeModeImage src="/img/risks.svg" />
    </Box>
    <Box margin="medium">
      <Subheading>KNOW WHAT TO FIX, AND HOW TO FIX IT</Subheading>
      <Text size="xxlarge" margin={{ top: `small` }} weight="bold">
        Discover Your Digital Footprint
      </Text>
      <Paragraph>
        The Pentester Dashboard allows non-technical staff to review findings
        related to the company technology and data leaks such as passwords.
        Technical users have a separate dashboard which provides detailed
        results, and instruction on how to mitigate items found.
      </Paragraph>
      <Box alignSelf="start">
        <Button primary href="#cta" label="Start Scan Now" color="brand" />
      </Box>
    </Box>
  </Box>
);
